.root {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 32px clamp(16px, 5vw, 48px);
}

.content {
  position: relative;
  z-index: 1;
  max-width: 720px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
}

.headline {
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 700;
  color: var(--color-brand-primary);
  letter-spacing: -0.01em;
}

.subheading {
  font-size: 15px;
  color: var(--color-text-secondary);
  line-height: 1.6;
  max-width: 560px;
  margin-bottom: 20px;
}
